import request from '@/utils/request'


// 查询联盟余额记录列表
export function listUnionBalanceRecord(query) {
  return request({
    url: '/union/union/balance/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询联盟余额记录分页
export function pageUnionBalanceRecord(query) {
  return request({
    url: '/union/union/balance/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询联盟余额记录详细
export function getUnionBalanceRecord(data) {
  return request({
    url: '/union/union/balance/record/detail',
    method: 'get',
    params: data
  })
}

// 新增联盟余额记录
export function addUnionBalanceRecord(data) {
  return request({
    url: '/union/union/balance/record/add',
    method: 'post',
    data: data
  })
}

// 修改联盟余额记录
export function updateUnionBalanceRecord(data) {
  return request({
    url: '/union/union/balance/record/edit',
    method: 'post',
    data: data
  })
}

// 删除联盟余额记录
export function delUnionBalanceRecord(data) {
  return request({
    url: '/union/union/balance/record/delete',
    method: 'post',
    data: data
  })
}
